import React, { useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import { server } from "../../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../../store/stateFunctions";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

const EditOrganizationDetails = () => {
  const user = useSelectAccess("Industry User");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      business_name: "",
      owner: "",
      mobile: "",
      email: "",
      details: "",
      address: "",
      landmark: "",
      city: "",
      pincode: "",
      location: "",
      url1: "",
    },
    validationSchema: yup.object({
      business_name: yup.string().required("Enter your Business Name"),
      mobile: yup
        .string()
        .matches(/^\d{10}$/, "Enter a valid 10-digit contact number")
        .required("Enter your Contact Number"),
      email: yup
        .string()
        .email("Enter a valid Email")
        .required("Enter your Email"),
      owner: yup.string().required("Enter your owner name"),
      details: yup.string().required("Enter Business details in description"),
      address: yup.string().required("Enter your Business Address"),
      landmark: yup.string().required("Enter Landmark"),
      city: yup.string().required("Enter your City Name"),
      pincode: yup.string().required("Enter your pincode"),
      location: yup.string().required("Enter your Location"),
      url1: yup.string().required("Enter your website url"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        const response = await server.put(
          "/orgdetails/updateorg_details",
          values,
          {
            headers: {
              Authorization: user.authToken,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
        toast.success(" updated successfully");
        navigate("/industryprofile");
      } catch (error) {
        if (error instanceof AxiosError && error.response?.data?.message) {
          toast.error(error.response.data.message);
        } else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else {
          toast.error("Failed to update profile");
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await server.get("/orgdetails/getindorg_details", {
          headers: {
            Authorization: user.authToken,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        console.log("Fetched data:", response.data);

        // Assuming the array has only one item, use it to set form values
        const firstItem = response.data[0];
        if (firstItem) {
          formik.setValues(firstItem);
        }
      } catch (error) {
        if (error.response?.status === 401) {
          navigate("/loginorg");
        }
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [navigate, user.authToken, formik.setValues]);

  return (
    <div>
      <section>
        <div className="container-xl mb-5">
          <form
            className="needs-validation d-flex flex-column gap-2"
            onSubmit={formik.handleSubmit}
          >
            <div className="">
              <h5 className="mb-3">Business Details</h5>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <TextField
                    name="business_name"
                    //   margin="dense"
                    type="text"
                    value={formik.values.business_name}
                    onChange={formik.handleChange}
                    placeholder="Shop Name"
                    variant="outlined"
                    label="Business Name"
                    fullWidth
                    required
                  ></TextField>
                </div>

                <div className="col-md-6  mb-3">
                  <TextField
                    name="owner"
                    //   margin="dense"
                    type="text"
                    value={formik.values.owner}
                    onChange={formik.handleChange}
                    placeholder="Owner's Full Name"
                    variant="outlined"
                    label="Owner"
                    fullWidth
                    required
                  ></TextField>
                </div>
              </div>
              <div className="row  mb-3">
                <div className="col-md-6">
                  <TextField
                    name="mobile"
                    //   margin="dense"
                    type="number"
                    value={formik.values.mobile}
                    onChange={formik.handleChange}
                    // disabled={!!props.edit}

                    placeholder="Mobile Number"
                    variant="outlined"
                    label="Business Mobile Number"
                    fullWidth
                    disabled
                    required
                  ></TextField>
                </div>

                <div className="col-md-6">
                  <TextField
                    name="email"
                    //   margin="dense"
                    type="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    placeholder="Business Email"
                    variant="outlined"
                    label="Business Email"
                    disabled
                    fullWidth
                    required
                  ></TextField>
                </div>
              </div>
              <div className=" mb-3">
                <TextField
                  name="details"
                  // margin="dense"
                  type="text"
                  value={formik.values.details}
                  onChange={formik.handleChange}
                  placeholder="Describe your business (min 200 chars)"
                  variant="outlined"
                  label="Business Details"
                  fullWidth
                  multiline
                  minRows={3}
                  required
                ></TextField>
              </div>
            </div>

            <div>
              <h5 className="mb-3">Address Details</h5>
              <div>
                <div className="row  mb-3">
                  <div className="col-md-6">
                    <TextField
                      name="address"
                      type="text"
                      //   margin="dense"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      placeholder="Address"
                      variant="outlined"
                      label="Address"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                  <div className="col-md-6">
                    <TextField
                      name="landmark"
                      type="text"
                      //   margin="dense"
                      value={formik.values.landmark}
                      onChange={formik.handleChange}
                      placeholder="Near Natraj Society"
                      variant="outlined"
                      label="Landmark"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <TextField
                      name="city"
                      type="text"
                      //   margin="dense"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      placeholder="City"
                      variant="outlined"
                      label="City"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                  <div className="col-md-6 mb-3">
                    <TextField
                      name="pincode"
                      type="number"
                      //   margin="dense"
                      value={formik.values.pincode}
                      onChange={formik.handleChange}
                      placeholder="412216"
                      variant="outlined"
                      label="pincode"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div>
                      <TextField
                        name="location"
                        type="text"
                        //   margin="dense"
                        value={formik.values.location}
                        onChange={formik.handleChange}
                        placeholder="Geo Location"
                        variant="outlined"
                        label="Organization/Institute Geo Location"
                        fullWidth
                        required
                      ></TextField>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <TextField
                        name="url1"
                        type="text"
                        //   margin="dense"
                        value={formik.values.url1}
                        onChange={formik.handleChange}
                        placeholder="Website Url"
                        variant="outlined"
                        label="Website Url"
                        fullWidth
                        required
                      ></TextField>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center">
              <span className="mb-1 d-block">
                <input type="checkbox" name="" id="" /> &nbsp; All The Above
                Information is Correct and If It Is Wrong Then I Am Responsible
                For The Same.
              </span>
              <Button
                className="banner text-white p-1 rounded-2 border-0 w-50 my-3"
                type="submit"
              >
                Update
              </Button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default EditOrganizationDetails;
